import { render, staticRenderFns } from "./PersonnelDetail.vue?vue&type=template&id=82a7015a&scoped=true"
import script from "./PersonnelDetail.vue?vue&type=script&lang=js"
export * from "./PersonnelDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonnelDetail.vue?vue&type=style&index=0&id=82a7015a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a7015a",
  null
  
)

export default component.exports